import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dcf9058"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-wrap items-center justify-center m-auto gap-2 mb-4" }
const _hoisted_2 = { class: "flex align-top gap-2 pt-4 pr-4 pl-4" }
const _hoisted_3 = { class: "sm:w-20 sm:h-20 h-[94px] w-[120px] flex-shrink-0" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "font-montserrat text-lg" }
const _hoisted_7 = { class: "font-montserrat text-gray-300 text-sm" }
const _hoisted_8 = {
  key: 0,
  class: "whitespace-nowrap"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full !border my-2 rounded-full border-gray-500" }, null, -1))
const _hoisted_10 = { class: "flex flex-col gap-3 pb-4 pr-4 pl-4" }
const _hoisted_11 = { class: "flex justify-between items-center font-montserrat text-sm font-semibold" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "mr-2 whitespace-nowrap" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 1,
  class: "pt-4 pb-2 text-sm text-gray-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomSlider = _resolveComponent("CustomSlider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("div", {
      key: _ctx.book.tenant.id,
      class: "rounded-xl shadow-md myMatchesClue w-[580px] sm:w-[320px] border border-gray-500"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.checkImage(_ctx.book.tenant.gallery),
            alt: _ctx.book.tenant.name,
            class: "w-full m:w-20 sm:h-20 h-[94px] rounded-lg"
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.capitalizeFirstLetter(_ctx.book.tenant.name)), 1),
          _createElementVNode("div", _hoisted_7, [
            _createTextVNode(_toDisplayString(_ctx.capitalizeFirstLetter(_ctx.book.tenant.address)) + " ", 1),
            (_ctx.book.distance)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, " · " + _toDisplayString(_ctx.book.distance), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", null, _toDisplayString(_ctx.beautifyShortDate(_ctx.date, false)), 1),
          (_ctx.book.bestPriceLocalized)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.capitalizeFirstLetter(_ctx.$t("starting_from"))) + ": ", 1),
                _createElementVNode("span", {
                  innerHTML: _ctx.parsedBestPrice(_ctx.book.bestPriceLocalized.withoutTaxes, _ctx.book.bestPriceLocalized.amountStr),
                  class: "whitespace-nowrap"
                }, null, 8, _hoisted_14)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          (_ctx.book.times && _ctx.book.times.length > 0)
            ? (_openBlock(), _createBlock(_component_CustomSlider, {
                key: 0,
                hours: _ctx.book.times,
                tenantId: _ctx.book.tenant.id,
                tenantName: _ctx.book.tenant.name,
                tenantPrivate: _ctx.book.tenant.private,
                allowShowMore: _ctx.allowShowMore,
                onHourSelected: _ctx.hourSelected
              }, null, 8, ["hours", "tenantId", "tenantName", "tenantPrivate", "allowShowMore", "onHourSelected"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t("search_no_resources_found")), 1))
        ])
      ])
    ]))
  ]))
}